<template>
  <div class="scan_results modern-grid">
    <scan-result
      v-for="(sr, i) in scanResults"
      :key="sr.received_at"
      :scan-result="sr"
      :previous="i === 0 ? null : scanResults[i-1]"
      class="extract-card"
    />
  </div>
</template>

<script>
import ScanResult from './ScanResult'

export default {
  components: { ScanResult },
  props: {
    scanResults: Array
  }
}
</script>

<style scoped>
.modern-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 2rem;
  margin-top: 1rem;
}
.extract-card {
  background: #fff;
  border-left: 6px solid #3273dc;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(50, 115, 220, 0.08);
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  margin-bottom: 1rem;
  transition: box-shadow 0.2s, border-color 0.2s;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.extract-card:hover {
  box-shadow: 0 6px 24px rgba(50, 115, 220, 0.14);
  border-left-color: #2756a5;
  background: #f8fbff;
}
</style>